import { ChangeEvent } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Textarea } from '@mantine/core';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const EventDescriptionInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { description } = values;

    const updateDescription = (evt: ChangeEvent<HTMLTextAreaElement>) => {
        updateValues({
            description: evt.target.value,
        });
    };

    return (
        <Textarea
            id="event-description-input"
            label={intl.formatMessage(messages.title)}
            placeholder={intl.formatMessage(messages.titlePlaceholder)}
            form="event-handler-form"
            maxLength={500}
            onChange={updateDescription}
            value={description}
            minRows={3}
            autosize
            title={intl.formatMessage(messages.title)}
            radius="md"
            size="md"
        />
    );
};

const messages = defineMessages({
    title: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventDescriptionInput.EventDescriptionInput.title',
        defaultMessage: 'Notatki',
    },
    titlePlaceholder: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventDescriptionInput.EventDescriptionInput.titlePlaceholder',
        defaultMessage: 'Wprowadź notatki',
    },
});

export default EventDescriptionInput;
